import {
    Category,
    SgmService,
    Subcategory,
} from './SgmSearchApiClient';
import { ObjectsWithoutIdProperty, ObjectsWithoutIdPropertyEnum } from './SgmSearchApiSchemaTypes';

export class BaseSgmSearchApiSchema {
    protected static getId(value: ObjectsWithoutIdProperty, type: ObjectsWithoutIdPropertyEnum): string {
        switch (type) {
            case ObjectsWithoutIdPropertyEnum.Category: {
                return (value as Category).key || '';
            }
            case ObjectsWithoutIdPropertyEnum.SgmService: {
                return (value as SgmService).serviceKey || '';
            }
            case ObjectsWithoutIdPropertyEnum.Subcategory: {
                return (value as Subcategory).key || '';
            }
            default:
                // The following line guarantees that every action in the KnownAction union has been covered by a case above
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const exhaustiveCheck: never = type;
        }
        return '';
    }
}
